import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { NbDialogService } from "@nebular/theme";
import { UserService } from "../../../@core/services/user.service";

import { DialogYesNoPromptComponent } from "../../dialog-yesno-prompt/dialog-yesno-prompt.component";
import { find, remove, clone } from "lodash";
import { Router } from "@angular/router";
import { DialogFeedbackComponent } from "../../dialog-feedback/dialog-feedback.component";
import Feedback from "../../../models/feedback.model";
import { FeedbackService } from "../../../services/feedback.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "ngx-view-feedback",
  styleUrls: ["./view-feedback.component.scss"],
  templateUrl: "./view-feedback.component.html",
})
export class ViewFeedbackComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() feedback: Feedback;
  @Input() mode?: string = "home"; //home / tutor / detail
  @Input() isMore? = false;
  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() onEdit: EventEmitter<any> = new EventEmitter();

  loading = false;
  submitted = false;
  view = "question";
  uid = "";

  constructor(
    public userService: UserService,
    private feedbackService: FeedbackService,
    private dialogService: NbDialogService,
    private router: Router
  ) {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
        } else {
          this.uid = "anonymous";
        }
      });
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  reply() {
    this.view = "replies";
  }

  closeReply() {
    this.view = "main";
  }

  loadContent(value) {
    this.isMore = value;
  }

  confirm(item: Feedback) {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có đồng ý tiếp nhận Góp Ý / Báo lỗi trường hợp này?",
          description: `Khi đồng ý, nhớ Like và Comment để tương tác với người gửi yêu cầu`,
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.submitted = true;
          this.loading = true;

          this.feedbackService
            .confirm(item)
            .then((result) => {
              item.status = 2;

              this.submitted = false;
              this.loading = false;
            })
            .catch((err) => {
              this.submitted = false;
              this.loading = false;
            });
        }
      });
  }

  navigateRef(item) {
    if (item.courseId != "") {
      this.router.navigateByUrl(`/course/${item.courseId}`);
    } else if (item.quizId != "") {
      this.router.navigateByUrl(`/quiz/${item.quizId}`);
    }
  }

  tagSelected(tag) {
    //console.log("tagSelected:", tag);
  }

  delete(item) {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa nội dung này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.feedbackService
            .delete(item.id)
            .then((result) => {
              this.loading = false;
              this.submitted = false;
              this.onDelete.emit(item.id);
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
            });
        }
      });
  }

  edit(item: Feedback) {
    let lecBk = new Feedback();
    lecBk = clone(item);
    this.dialogService
      .open(DialogFeedbackComponent, {
        context: {
          header: "Cập nhật bài viết",
          mode: "edit",
          feedback: lecBk,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          item = value;
          this.feedback = value;
          this.onEdit.emit(value);
        }
      });
  }
}
